import { jsx as _jsx } from "react/jsx-runtime";
import 'react';
import classNames from 'classnames';
import TagList from '../tag/TagList';
import Tag from '../tag/Tag';
const TagManagerItemList = (props) => {
    const { tags, onRemoveFromTagList = () => { } } = props;
    return (_jsx(TagList, Object.assign({ inline: false }, { children: tags.map(tag => {
            const tagClasses = classNames(tag.toAdd && 'border-color-success text-color-success', tag.toRemove && 'border-color-danger text-color-danger');
            return (_jsx(Tag, Object.assign({ className: tagClasses, deletable: true, round: false, onClick: () => onRemoveFromTagList(tag) }, { children: tag.label }), tag.label));
        }) })));
};
export default TagManagerItemList;
